import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
export const D2DmppErrorPage = () => {
    const {
        mppConfig: { contentNotFoundimg }
    } = useContext(ThemeContext)

    const closeBtnClick = () => {
        if (window && window.parent) {
            var parent = window.parent;
            parent.postMessage("Close", "*");
        }
    }

    return (
        <div className="d2dMppErrorPage modal-body" role="status" aria-live="polite">
            <div className="contentNotFoundimg">
                <img src={contentNotFoundimg} alt="Content Not found Image" />
            </div>
            <div className="errorMsg">
                <h5>Please Try Again</h5>
                <p>We’re sorry, something went wrong and we can’t complete your request. Close the window and try again.</p>
            </div>
            <Button
                className="d2dMailBtn"
                onClick={closeBtnClick}
            > CLOSE
            </Button>
        </div>
    )
}